import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';

const initialState = {
    archivedPackages: {
        packages:[],
        isLoading: false,
        error: "",
        currentPage: 1,
        pageCount: 0,
        search: '',
        archiveSelectedFacility: {value: null, label: ''},
        spoolSearch: "",
    },
}

const archivedPackages = createNamespacer('ARCHIVED_PACKAGES')

export const archivedPackagesReducer = createReducer(initialState.archivedPackages, {
    [archivedPackages('SET_PACKAGES')]:(state, action) => {
        return {
            ...state,
            packages: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [archivedPackages("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [archivedPackages("SET_PAGE")]:(state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [archivedPackages("SET_ERROR")]:(state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [archivedPackages("SET_SEARCH_PACKAGES")]:(state, action) => {
        return {
            ...state,
            search: action.payload.value,
        }
    },
    [archivedPackages("SET_CLEAR_SEARCH")]:(state, action) => {
        return {
            ...state,
            search: initialState.search
        }
    },
    [archivedPackages("SET_ARCHIVE_SELECTED_FACILITY")]:(state, action) => {
        return {
            ...state,
            archiveSelectedFacility: action.payload.value
        }
    },
    [archivedPackages("SET_SPOOL_SEARCH")]:(state, action) => {
        return {
            ...state,
            spoolSearch: action.payload.value
        }
    }
})
   